import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';

import TimeExpensePage from './TimeExpensePage';

export default function getRoutes(isLoggedIn: boolean) {
    return [<RoutePrivate key="time" path="/time-expense" component={TimeExpensePage} isLoggedIn={isLoggedIn} />];
}



// WEBPACK FOOTER //
// ./src/components/time/TimeExpense.Routes.tsx